<template>
  <v-data-table
    :headers="headers"
    :items="timeSheets"
    sort-by="ClockIn"
    sort-desc
    class="elevation-1"
    :loading="isLoading"
    loading-text="Loading Time Sheet"
    height="550"
  >
    <template v-slot:item.clockin="{ item }">
      <v-chip :color="getStatusColor(item.ClockInStatus)" dark>
        {{ item.clockin }}
      </v-chip>
    </template>
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Timesheet</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          clearable
          flat
          solo-inverted
          hide-details
          prepend-inner-icon="search"
          label="search"
          class="desktop"
        ></v-text-field>
        <v-spacer></v-spacer>

        <!-- <v-btn color="#2b3990" class="mb-2 white--text" @click="showAdd()">
          <v-icon left>add</v-icon>
          Add Timesheet
        </v-btn> -->
        <SaveDialog
          :titleForm="titleForm"
          :timesheet="timesheet"
          :getTimeSheets="getTimeSheets"
          :action="action"
        />
      </v-toolbar>
      <v-text-field
        v-model="search"
        clearable
        flat
        solo-inverted
        hide-details
        prepend-inner-icon="search"
        label="search"
        class="mobile ml-5 mr-5 mb-3 mt-3"
      ></v-text-field>
    </template>

    <template
      v-slot:[`item.actions`]="{ item }"
      v-if="allowAccessAction.includes(role)"
    >
      <v-icon small class="mr-2" @click="viewTimeSheet(item)"> mdi-eye </v-icon>

      <v-icon small @click="deleteTimeSheet(item)"> mdi-delete </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import moment from "moment";
const TimesheetService = require("../../service/timesheet.service");
import SaveDialog from "./SaveDialog.vue";
import { mapMutations, mapState, mapGetters } from "vuex";

import { setUserTz } from "../../../utils/timezone";
export default {
  components: {
    SaveDialog,
  },
  data: function () {
    return {
      headers: [
        { text: "Schedule Date", value: "ScheduleDate" },
        {
          text: "Clocked In Date",
          align: "start",
          sortable: false,
          value: "date",
        },
        { text: "Clocked In", value: "clockin" },
        { text: "Clocked Out", value: "clockout" },
        // { text: "Scheduled In", value: "startDate" },
        // { text: "Scheduled Out", value: "endDate" },
        { text: "Total Hours", value: "totalHour" },
        { text: "Location IN", value: "locationLogin" },
        { text: "Location OUT", value: "locationLogout" },
        { text: "Client", value: "client" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      dialog: false,
      timeSheets: [],
      role: localStorage.getItem("userRole"),
      menu: false,
      signed: false,
      search: "",
      text: "",
      staffID: this.$route.params.employeeID,
      staff: "",
      titleForm: "New Time Sheet",
      timeSheetID: "",
      //newClockIn: "",
      newClockOut: "",
      msg: false,
      isLoading: true,
      timesheet: {},
      action: "",
    };
  },

  computed: {
    ...mapState("timesheet", {
      allowAccessAction: "allowAccessAction",
    }),

    ...mapGetters({
      getUserTimezone: "timezones/getUserTimezone",
      getDefaultTz: "timezones/getDefaultTz",
    }),

    userTimezone() {
      const data = {
        userTimezone: this.getUserTimezone,
        defaultTz: this.getDefaultTz,
      };
      return setUserTz(data);
    },
  },

  async created() {
    this.staffID = this.$route.params.employeeID;
    await this.getTimeSheets();
  },

  methods: {
    ...mapMutations({
      setSnackbar: "SET_SNACKBAR",
    }),

    ...mapMutations("timesheet", {
      setSaveDialog: "SET_SAVE_DIALOG",
      setTimeSheet: "SET_TIMESHEET",
    }),

    getTimeSheets: function () {
      this.isLoading = true;
      let employeeID = this.staffID;

      //.get(`${url}/timeSheets/${employeeID}`)
      TimesheetService.getById(employeeID)
        .then((res) => {
          this.timeSheets = [];
          let dateNowUTC = moment.utc(new Date()).format("YYYY-MM-DD");
          res.data.timeSheet.forEach((value) => {
            let clockinFull = "";
            // let clockoutFull = "";
            let totalTimeFull = "";
            let dateClockInUTC = moment
              .utc(new Date(value.ClockIn))
              .format("YYYY-MM-DD");

            value.ScheduleDate = moment(new Date(value.ClockInSchedule)).tz(this.userTimezone).format("YYYY-MM-DD");

            value.ClockOut = value.ClockOut === undefined ? "" : value.ClockOut;

            value.date = moment(new Date(value.ClockIn))
              .tz(this.userTimezone)
              .format("YYYY-MM-DD");
            value.clockin = moment(new Date(value.ClockIn)).format("hh:mm a");
            clockinFull = moment(new Date(value.ClockIn));

            // for debugging purposes
            // value.startDate = DateTimeUtil.toLocalDateTime(value.shift.StartDate);
            // value.endDate = DateTimeUtil.toLocalDateTime(value.shift.EndDate);

            //SET TIMESHEET ID TO USE FOR LOGOUT
            if (dateNowUTC === dateClockInUTC && value.ClockOut === "") {
              this.currentTimesheetID = value._id;
            }

            //geolocation
            if (value && value.GeolocationIn && value.GeolocationIn.length) {
              value.GeolocationIn.forEach((val) => {
                value.locationLogin =
                  val["Street"] + ", " + val["City"] + ", " + val["Country"];

                value.LocationInStreet = val["Street"];
              });
            }

            if (value.Late !== undefined && value.Late > 0) {
              value.ClockInStatus = "LATE";
            }

            value.clockout =
              value.ClockOut === ""
                ? "- -"
                : moment(new Date(value.ClockOut)).format("hh:mm a");
            // clockoutFull = moment(new Date(value.ClockOut));

            //geolocation out
            if (value && value.GeolocationOut && value.GeolocationOut.length) {
              value.GeolocationOut.forEach((val) => {
                value.locationLogout =
                  val["Street"] + ", " + val["City"] + ", " + val["Country"];
                value.LocationOutStreet = val["Street"];
              });
            }

            if (value.ClockOut === "") {
              totalTimeFull = clockinFull.diff(clockinFull);
            } else {
              const clockinFull = moment(
                new Date(`${value.date} ${value.clockin}`),
                "YYYY-MM-DD HH:mm"
              );
              const clockoutFull = moment(
                new Date(`${value.date} ${value.clockout}`),
                "YYYY-MM-DD HH:mm"
              );

              totalTimeFull = clockoutFull.diff(clockinFull);

              if (totalTimeFull < 0) {
                totalTimeFull = clockoutFull.add(1, "days").diff(clockinFull);
              }
            }

            let duration = moment.duration(totalTimeFull);
            let hours = duration.hours();
            let minutes = duration.minutes();

            let totaltime = `${hours}h ${minutes}m`;

            value.totalHour = totaltime;
            this.totalWeeklyHour =
              parseFloat(this.totalWeeklyHour) +
              parseFloat(Math.floor(minutes));

            let clientName = "";
            value.clients.forEach((val, index) => {
              if (index === value.clients.length - 1) {
                clientName += val.Name;
              } else {
                clientName += val.Name + ", ";
              }
            });

            value.client = clientName;

            this.timeSheets.push(value);
          });
        })
        .finally(() => (this.isLoading = false));
    }, //END GET TIMESHEET

    viewTimeSheet(item) {
      this.timesheet = item;
      this.setTimeSheet(item);
      this.titleForm = "Viewing Time";
      this.action = "update";
      this.setSaveDialog(true);

      /*
      this.newClockOut = null;
      this.clockOutAvailable = false;
      this.newClock = [];
      this.newClockID = 0;
      this.titleForm = "Viewing Time";
      this.newClockIn = moment(new Date(item.ClockIn)).format("YYYY-MM-DD hh:mm a"); //First item is clockin time
      this.newClock.push(item.ClockIn);
      this.newClockID = item._id;
      if (item.ClockOut == "") {
        this.newClockOut = null;
      } else {
        this.clockOutAvailable = true;
        this.newClockOut = moment(new Date(item.ClockOut)).format("YYYY-MM-DD hh:mm a"); //second item is clockout time
        this.newClock.push(item.ClockOut);
      }
      */
    }, //END VIEWTIMESHEET

    deleteTimeSheet(item) {
      const timesheetID = item._id;
      const response = confirm(
        "Are you sure you want to delete this time sheet entry?"
      );

      if (response === true) {
        if (timesheetID != null) this.timeSheetDelete(timesheetID);
      }
    },

    timeSheetDelete(id) {
      TimesheetService.deleteById(id).then((response) => {
        this.getTimeSheets();
        if (response.status === 400) {
          response.json().then(function (data) {
            return data.msg;
          });
        }
        this.setSnackbar({
          show: true,
          text: "The time sheet entry has been deleted successfully.",
          color: "green accent-4",
        });
      });
    },

    showAdd() {
      this.titleForm = "Insert Timesheet";
      this.setTimeSheet({});
      this.action = "add";
      this.setSaveDialog(true);
    },

    getStatusColor(status) {
      if (status === "LATE") return "red";
      else return "green";
    },
  },
};
</script>
